<template>
  <div id="main-view" class="w-full" :style="{ '--delay': delay }">
    <div
      class="
        w-full
        bg-white
        h-14
        rounded-md
        flex
        justify-between
        px-6
        mb-4
        shadow-sm
      "
    >
      <p
        class="group text-left self-center text-lg font-semibold cursor-pointer"
        @click="navigate"
      >
        <font-awesome-icon
          id="arrow"
          :icon="['far', 'long-arrow-left']"
          class="mr-2 group-hover:animate-bounce-left"
        />
        {{ $tc("package", 1) }} {{ $route.params.id }}
      </p>

      <core-list-actions
        :open.sync="actionsVisible"
        :actions="rowActions"
        :entity="entity"
      >
        <template v-slot:activator="">
          <div class="group">
            <p class="text-right text-xs cursor-pointer pt-5">
              <font-awesome-icon
                :icon="['far', 'cog']"
                class="mr-2 group-hover:animate-bounce-once"
              />
              {{ $t("functions") }}
            </p>
          </div>
        </template>
      </core-list-actions>
    </div>

    <div
      v-if="deleted"
      class="
        w-full
        bg-white
        h-14
        rounded-md
        flex
        justify-between
        px-6
        mb-4
        shadow-sm
      "
      :style="{ '--i': 1 }"
    >
      <p class="text-left self-center text-lg font-semibold">
        {{ $t("package_deleted") }}
      </p>
    </div>
    <div v-if="!$_.isEmpty(entity)" class="w-full md:flex">
      <div class="w-full md:w-2/3 mr-4">
        <transition appear leave name="detail-animation" mode="in-out">
          <div
            v-if="show && ticket !== null"
            class="
              bg-white
              rounded-md
              shadow-sm
              w-full
              pb-5
              mb-4
            "
            :style="{ '--i': 1 }"
          >
            <h4 class="px-6 pt-5 w-full font-medium text-lg">
              <font-awesome-icon
                :icon="['far', 'ticket']"
                class="mr-2 transform -rotate-45"
              />
              {{ $t('ticket') }}
            </h4>
            <div class="w-full col-span-1 md:col-span-2 grid grid-cols-3">
              <div class="col-span-3 md:col-span-1 px-6 py-3 mt-auto">
                <p class="text-sm pb-1">{{ $t('type') }}</p>
                <core-input
                  readonly
                  :value="ticket.type.name"
                  class="w-full">
                </core-input>
              </div>
              <div class="col-span-3 md:col-span-1 px-6 py-3 mt-auto">
                <p class="text-sm pb-1">{{ $t('status') }}</p>
                <core-input
                  readonly
                  :value="getStatus(ticket.status)"
                  class="w-full">
                </core-input>
              </div>
              <div v-for="attribute, index in ticket.attributes" :key="attribute.id" class="col-span-3 md:col-span-1 px-6 py-3 mt-auto">
                <div v-if="attribute.type == 'text'" class="relative">
                <p class="text-sm pb-1 w-full">{{ attribute.name }}</p>
                  <core-input
                    v-model="ticket.attributes[index].value"
                    :value="attribute.value"
                    class="w-full"
                    :error="!ticket.attributes[index].value || ticket.attributes[index].value == ''"
                  >
                  </core-input>
                  <div class="flex-col cursor-pointer flex has-tooltip absolute top-0 -left-6">
                    <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
                    </svg>
                    <p
                      class="tooltip min-w-[200px] bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
                      style=""
                      >{{ attribute.description }}
                    </p>
                  </div>
                </div>
                <div v-if="attribute.type == 'number'" class="relative">
                  <p class="text-sm pb-1 w-full">{{ attribute.name }}</p>
                  <core-number
                    v-model="ticket.attributes[index].value"
                    class="mt-3 w-full items-stretch max-w-full"
                    :error="!ticket.attributes[index].value || ticket.attributes[index].value == ''"
                  />
                  <div class="flex-col cursor-pointer flex has-tooltip absolute top-0 -left-6">
                    <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
                    </svg>
                    <p
                      class="tooltip min-w-[200px] bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
                      style=""
                      >{{ attribute.description }}
                    </p>
                  </div>
                </div>
                <div v-if="attribute.type == 'textarea'" class="relative">
                  <p class="text-sm pb-1 w-full">{{ attribute.name }}</p>
                  <core-input
                    v-model="ticket.attributes[index].value"
                    class="mt-3 w-full items-stretch max-w-full"
                    input-type="textarea"
                    placeholder=""
                    :error="!ticket.attributes[index].value || ticket.attributes[index].value == ''"
                    @change="val => ticket.attributes[index].value = val"
                  />
                </div>
                <div v-if="attribute.type == 'select'" class="relative">
                  <p class="text-sm pb-1">{{ attribute.name }}</p>
                  <core-select
                    v-model="ticket.attributes[index].value"
                    class="w-full items-stretch max-w-full"
                    :options="attribute.options"
                    :label="attribute.name"
                    label-key="label"
                    value-key="value"
                    style="width: 100%"
                    :error="!ticket.attributes[index].value"
                    @input="val => ticket.attributes[index].value = val"
                  />
                  <div class="flex-col cursor-pointer flex has-tooltip absolute top-0 -left-6">
                    <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
                    </svg>
                    <p
                      class="tooltip min-w-[200px] bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
                      style=""
                      >{{ attribute.description }}
                    </p>
                  </div>
                </div>
                <div v-if="attribute.type == 'dor'|| attribute.type == 'file' || attribute.type == 'file_with_pdf'" class="relative">
                  <input :ref="attribute.key" class="hidden" type="file" accept="image/*,.pdf,.docx,.xlsx" @change="val => addFileToAtt(val, attribute.key, index, false)">
                  <p class="absolute -top-2 right-0 font-semibold text-lg cursor-pointer" @click="$refs[attribute.key][0].click()">+</p>
                  <p class="text-sm pb-1">{{ attribute.name }}</p>
                  <a v-if="attribute.type == 'dor'" class="text-left" :href="attribute.options.link" target="_blank" rel="noopener noreferrer"><p class="text-left text-sm pb-1 underline">{{ $t('DOR') }} {{ $t('link') }}</p></a>
                  <div class="border rounded-md min-h-14 p-3 pt-4 overflow-hidden text-left" :class="!attribute.value ? 'border-red-500' : 'border-gray-200'">
                    <a v-if="attribute.value && attribute.value.includes('https://cr-claims.s3.eu-central-1')" class="text-left" :href="attribute.value" target="_blank"><p class="text-sm break-words text-coolrunner-500 underline">{{ getFileAttributes(attribute.value, 'name') }}</p></a>
                    <p v-else class="text-sm break-words">{{ getFileAttributes(attribute.value, 'name') }}</p>
                  </div>
                  <div class="flex-col cursor-pointer flex has-tooltip absolute top-0 -left-6">
                    <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
                    </svg>
                    <p
                      class="tooltip min-w-[200px] bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
                      style=""
                      >{{ attribute.description }}
                    </p>
                  </div>
                </div>
                <div v-if="attribute.type == 'file[]'" class="relative">
                  <input :ref="attribute.key" class="hidden" type="file" accept="image/*,.pdf,.docx,.xlsx" @change="val => addFileToAtt(val, attribute.key, index, true)">
                  <p class="absolute -top-2 right-0 font-semibold text-lg cursor-pointer" @click="$refs[attribute.key][0].click()">+</p>
                  <p class="text-sm pb-1">{{ attribute.name }}</p>
                  <div class="border rounded-md min-h-14 p-3 pt-4 overflow-hidden text-left" :class="!attribute.value ? 'border-red-500' : 'border-gray-200'">
                    <div v-for="file, index in attribute.value" :key="file">
                      <a v-if="file.includes('https://cr-claims.s3.eu-central-1')" class="text-left" :href="file" target="_blank">
                        <p class="text-sm break-words text-coolrunner-500 underline" :class="{'mb-2' : index + 1 !== attribute.value.length}">
                          {{ getFileAttributes(file, 'name') }}
                        </p>
                      </a>
                      <p v-else class="text-sm break-words" :class="{'mb-2' : index + 1 !== attribute.value.length}">
                        {{ getFileAttributes(file, 'name') }}
                      </p>
                    </div>
                  </div>
                  <div class="flex-col cursor-pointer flex has-tooltip absolute top-0 -left-6">
                    <svg class="mt-0.5 ml-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
                    </svg>
                    <p
                      class="tooltip min-w-[200px] bg-gray-50 shadow-md rounded-md p-2 text-left font-default text-sm break-normal"
                      style=""
                      >{{ attribute.description }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-span-3 md:col-span-1 px-6 py-3 mt-auto">
                <p class="text-sm"></p>
                <core-button
                  type="coolrunner"
                  :disabled="updateTicketOkay"
                  @click="updateTicket()"
                  >{{ $t("update_entity", {entity: $t('ticket').toLowerCase()})}}
                </core-button>
              </div>
            </div>
          </div>
        </transition>
        <transition appear leave name="detail-animation" mode="in-out">
          <div
            v-if="show"
            class="
              bg-white
              rounded-md
              shadow-sm
              w-full
              pb-5
              mb-4
            "
            :style="{ '--i': 2 }"
          >
            <h4 class="px-6 pt-5 w-full font-medium text-lg">
              <font-awesome-icon :icon="['far', 'dolly']" class="mr-2" />
              {{ $t("shipment_info") }}
            </h4>
            <div class="w-full grid grid-cols-3">
              <div class="col-span-1 px-6 pt-5">
                <p class="w-full text-sm">{{ $t("carrier") }}</p>
                <div>
                  <img
                    :src="
                      `${URL_PREFIX}/images/carriers/${entity.carrier}.png?w=500&context=business_panel`
                    "
                    class="w-32"
                  />
                </div>
              </div>
              <div class="col-span-2 md:col-span-1 px-6 pt-5">
                <p class="w-full text-sm">{{ $t("package_number") }}</p>
                <p class="pt-2">{{ entity.package_number }}</p>
              </div>
              <div class="col-span-3 md:col-span-1 px-6 pt-5">
                <p class="w-full text-sm">{{ $t("status") }}</p>
                <div
                  v-if="!status"
                  class="
                    px-2
                    py-1
                    mt-2
                    max-w-min
                    rounded
                    border border-gray-300
                    bg-gray-100
                    text-gray-500
                  "
                >
                  <p>Loading..</p>
                </div>
                <div
                  v-if="status && status !== 'cancelled_item'"
                  class="max-w-min rounded mt-2"
                  :class="borderColor(status.code)"
                >
                  <p class="px-2 pt-1" :class="textColor(status.code)">
                    {{ $t(status.status) }}
                  </p>
                </div>
                <div
                  v-if="status && status == 'cancelled_item'"
                  class="max-w-min rounded mt-2"
                  :class="borderColor(status)"
                >
                  <p class="px-2 pt-1" :class="textColor(status)">
                    {{ $t(status) }}
                  </p>
                </div>
              </div>
              <div v-if="entity.pcn_order_id" class="col-span-2 md:col-span-1 px-6 py-3">
                <core-button type="coolrunner"
                @click="goToWMS(entity.pcn_order_id)">
                  {{$t('go_to_wms_order')}}
                </core-button>
              </div>
            </div>
          </div>
        </transition>
        <transition appear name="detail-animation" mode="in-out">
          <div
            v-if="show"
            class="
              bg-white
              rounded-md
              shadow-sm
              w-full
              pb-5
              mb-4
            "
            :style="{ '--i': 4 }"
          >
            <h4 class="px-6 pt-5 w-full font-medium text-lg">
              <font-awesome-icon :icon="['far', 'receipt']" class="mr-2" />
              {{ $t("shipment_details") }}
            </h4>
            <div class="w-full grid grid-cols-3">
              <div class="col-span-3 md:col-span-1 pl-6 pr-6 md:pr-0 pt-3">
                <p class="text-sm pb-1">{{ $t("created") }}</p>
                <core-input
                  readonly
                  :value="formatTime(entity.created_at)"
                  class="w-full"
                >
                </core-input>
              </div>
              <div class="col-span-3 md:col-span-1 pl-6 py-3 pr-6 md:pr-0">
                <p class="text-sm pb-1">{{ $t("labelless") }}</p>
                <core-input
                  readonly
                  :value="checkData(entity.labelless_code)"
                  class="w-full"
                >
                </core-input>
              </div>
              <div class="col-span-3 md:col-span-1 px-6 py-3">
                <p class="text-sm pb-1">{{ $t("insurance") }}</p>
                <core-input
                  readonly
                  :value="findInsurence(entity.insurance)"
                  class="w-full"
                >
                </core-input>
              </div>
              <div class="col-span-3 md:col-span-2 pl-6 py-3 pr-6 md:pr-0">
                <p class="text-sm pb-1">{{ $t("product") }}</p>
                <core-input
                  readonly
                  :value="checkData(entity.title)"
                  class="w-full"
                >
                </core-input>
              </div>
              <div class="col-span-3 md:col-span-1 px-6 py-3">
                <p class="text-sm pb-1">{{ $t("reference") }}</p>
                <core-input
                  readonly
                  :value="checkData(entity.reference)"
                  class="w-full"
                >
                </core-input>
              </div>
              <div class="col-span-3 md:col-span-2 pl-6 py-3 pr-6 md:pr-0">
                <p class="text-sm pb-1">{{ $t("droppoint") }}</p>
                <core-input
                  readonly
                  :value="checkServicePoint(entity.servicepoint)"
                  class="w-full"
                >
                </core-input>
              </div>
              <div class="col-span-3 md:col-span-1 px-6 py-3">
                <p class="text-sm pb-1">{{ $t("ordered_via") }}</p>
                <core-input
                  readonly
                  :value="checkContext(entity.context)"
                  class="w-full"
                >
                </core-input>
              </div>
            </div>
          </div>
        </transition>
        <transition appear name="detail-animation" mode="out-in">
          <div
            v-if="show"
            class="
              bg-white
              rounded-md
              shadow-sm
              w-full
              pb-5
              mb-4
            "
            :style="{ '--i': 5 }"
          >
            <h4 class="px-6 pt-5 w-full font-medium text-lg">
              <font-awesome-icon :icon="['far', 'cube']" class="mr-2" />
              {{ $t("package_details") }}
            </h4>
            <div class="w-full grid grid-cols-3">
              <div class="col-span-1 pl-6 py-3">
                <p class="text-sm pb-1">{{ $t("weight") }}</p>
                <core-input
                  readonly
                  :value="entity.weight"
                  suffix="g"
                  class="w-32"
                >
                </core-input>
              </div>
              <div class="col-span-3 md:col-span-2 pl-6 py-3 pr-6 md:pr-0">
                <p class="text-sm pb-1">{{ $t("dimensions") }}</p>
                <div class="flex">
                  <core-input
                    class="w-24"
                    readonly
                    :value="entity.height"
                    suffix="cm"
                  >
                  </core-input>
                  <p class="py-4 px-2">x</p>
                  <core-input
                    class="w-24"
                    readonly
                    :value="entity.width"
                    suffix="cm"
                  >
                  </core-input>
                  <p class="py-4 px-2">x</p>
                  <core-input
                    class="w-24"
                    readonly
                    :value="entity.length"
                    suffix="cm"
                  >
                  </core-input>
                </div>
              </div>
              <div class="col-span-1 pl-6 py-3">
                <p class="text-sm pb-1">{{ $t("price") }}</p>
                <core-input
                  readonly
                  :value="getPrice(entity)"
                  :suffix="
                    !entity.currency || entity.currency === 'DKK'
                      ? 'kr'
                      : entity.currency
                  "
                  class="w-32"
                >
                </core-input>
              </div>
              <div class="col-span-2 pl-6 py-3">
                <p class="text-sm pb-1">{{ $t("is_return") }}</p>
                <core-input
                  readonly
                  :value="checkReturn(entity.is_return)"
                  class="w-64"
                >
                </core-input>
              </div>
              <div v-if="entity.meta" class="col-span-1 pl-6 py-3">
                <p v-if="entity.meta.sorting" class="text-sm pb-1">{{ $t("sorting_weight") }}</p>
                <core-input
                  v-if="entity.meta.sorting"
                  readonly
                  :value="entity.meta.sorting.weight"
                  suffix="g"
                  class="w-32"
                >
                </core-input>
              </div>
              <div v-if="entity.meta" class="col-span-3 md:col-span-2 pl-6 py-3 pr-6 md:pr-0">
                <p v-if="entity.meta.sorting" class="text-sm pb-1">{{ $t("sorting_dimensions") }}</p>
                <div class="flex">
                  <core-input
                    v-if="entity.meta.sorting"
                    class="w-24"
                    readonly
                    :value="entity.meta.sorting.dimensions.height"
                    suffix="cm"
                  >
                  </core-input>
                  <p v-if="entity.meta.sorting" class="py-4 px-2">x</p>
                  <core-input
                    v-if="entity.meta.sorting"
                    class="w-24"
                    readonly
                    :value="entity.meta.sorting.dimensions.width"
                    suffix="cm"
                  >
                  </core-input>
                  <p v-if="entity.meta.sorting" class="py-4 px-2">x</p>
                  <core-input
                    v-if="entity.meta.sorting"
                    class="w-24"
                    readonly
                    :value="entity.meta.sorting.dimensions.length"
                    suffix="cm"
                  >
                  </core-input>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition v-if="show" appear name="detail-animation" mode="out-in">
          <div
            v-if="entity.order_lines"
            class="
              bg-white
              rounded-md
              shadow-sm
              w-full
              pb-5
              mb-4
            "
            :style="{ '--i': 7 }"
          >
            <h4 class="px-6 pt-5 w-full font-medium text-lg">
              <font-awesome-icon :icon="['far', 'box-open']" class="mr-2" />
              {{ $t("products") }}
            </h4>
            <div
              v-for="(product, index) in entity.order_lines"
              :key="index"
              class="w-full grid grid-cols-3"
            >
              <div class="col-span-2 pl-6 py-3 pt-8 md:pt-6">
                <p class="text-sm pb-1">{{ $t("item_number") }}</p>
                <core-input
                  readonly
                  :value="product.item_number"
                  class="w-full"
                >
                </core-input>
              </div>
              <div class="col-span-1 px-6 py-3 pt-8 md:pt-6">
                <p class="text-sm pb-1">{{ $t("price") }}</p>
                <core-input readonly :value="checkCostumsEntity('price', product.customs)" class="w-full">
                </core-input>
              </div>
              <div
                v-if="product.customs"
                class="col-span-2 pl-6 py-3 pt-8 md:pt-3"
              >
                <p class="text-sm pb-1">{{ $t("item_description") }}</p>
                <core-input
                  readonly
                  :value="checkCostumsEntity('description',product.customs)"
                  class="w-full"
                >
                </core-input>
              </div>
              <div class="col-span-1 px-6 py-3">
                <p class="text-sm pb-1">{{ $t("number_of_units") }}</p>
                <core-input readonly :value="product.qty" class="w-full">
                </core-input>
              </div>
              <div
                v-if="product.customs"
                class="col-span-2 pl-6 py-3 pt-8 md:pt-3"
              >
                <p class="text-sm pb-1">{{ $t("item_tariff") }}</p>
                <core-input
                  readonly
                  :value="checkCostumsEntity('tariff', product.customs)"
                  class="w-full"
                >
                </core-input>
              </div>
              <div class="col-span-1 px-6 py-3">
                <p class="text-sm pb-1">{{ $t("origin_country") }}</p>
                <core-input readonly :value="checkCostumsEntity('origin', product.customs)">
                </core-input>
              </div>
              <div class="grid grid-cols-4 col-span-3 pr-6">
                <div
                  v-if="product.cause"
                  class="col-span-2 pl-6 py-3 pt-8 md:pt-3"
                >
                  <p class="text-sm">{{ $t("return_cause") }}</p>
                  <core-input readonly :value="product.cause" class="w-full">
                  </core-input>
                </div>
                <div
                  v-if="product.comment"
                  class="col-span-2 pl-6 py-3 pt-8 md:pt-3"
                >
                  <p class="text-sm pb-1">{{ $t("return_comment") }}</p>
                  <core-input readonly :value="product.comment" class="w-full">
                  </core-input>
                </div>
              </div>
              <div
                v-if="index !== entity.order_lines.length - 1"
                class="col-span-3 h-[2px] bg-gray-200 my-4 mx-4"
              ></div>
            </div>
          </div>
        </transition>
        <transition v-if="show" appear name="detail-animation" mode="out-in">
          <div
            class="
              bg-white
              rounded-md
              shadow-sm
              w-full
              pb-5
            "
            :style="{ '--i': 7 }"
          >
            <h4 class="px-6 pt-5 w-full font-medium text-lg">
              <font-awesome-icon :icon="['far', 'route']" class="mr-2" />
              {{ $t("tracking_info") }}
            </h4>
            <core-tracking
              :package-number="entity.package_number"
              @latest_status_update="val => checkStatus(val)"
            />
          </div>
        </transition>
      </div>
      <div class="w-full mt-4 md:mt-0 md:w-1/3">
        <transition
          v-if="show && ticket"
          appear
          name="detail-animation"
          mode="out-in"
        >
          <div
            class="
              bg-white
              rounded-md
              shadow-sm
              w-full
              pb-7
              mb-5
            "
            :style="{ '--i': 3 }"
          >
            <h4 class="w-5/6 mx-auto pl-0.5 pt-5 text-lg">
              <font-awesome-icon :icon="['far', 'comments-alt']" class="mr-2" />
              {{ $t("conversation") }}
            </h4>
            <div
              id="container"
              class="notes h-96 border border-gray-200 w-5/6 mx-auto rounded-md p-3 overflow-y-scroll mt-3"
            >
              <div v-if="ticket.conversations.length !== 0">
                <div
                  v-for="message in ticket.conversations[0].messages"
                  :key="message.id"
                  class="note mb-5"
                >
                  <p class="text-xs" :class="{ 'text-right': message.created_by_user_id }">
                    {{ message.from_name }} - {{ convertUTCToLocal(message.created_at) }}
                  </p>
                  <div class="grid justify-items-stretch">
                    <div
                      class="note border border-gray-200 rounded-md p-3 max-w-[280px]"
                      :class="{
                        'bg-coolrunner-500 justify-self-end': message.created_by_user_id,
                        'bg-[#F5F7FA]': !message.created_by_user_id
                      }"
                    >
                      <div
                        :class="message.created_by_user_id ? 'partnerMessage text-white text-sm text-left' : 'text-sm text-left'"
                        v-html="message.body"
                      >
                      </div>
                      <p v-for="file in message.files"
                        :key="file.id" class="text-sm underline decoration-inherit" :class="{ 'partnerFile text-white': message.created_by_user_id }">
                        <a :href="file.url" target="_blank" rel="noopener noreferrer">{{ file.name }}</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="ticket.conversations.length !== 0">
              <div
                v-if="ticket.conversations[0].notification"
                class="w-5/6 mx-auto flex justify-end"
              >
                <core-button
                  class="mt-3"
                  type="coolrunner"
                  @click="removeNotice()"
                  >{{ $t("confirm_note") }}
                </core-button>
              </div>
            </div>
            <div class="w-5/6 mx-auto mt-3">
              <h4 class="pl-0.5 pt-5 text-lg">
                {{ $t("new_message") }}
              </h4>
              <core-input
                v-model="new_note"
                class="mt-3"
                input-type="textarea"
              />
              <div class="flex w-full mb-[10px]">
                <input ref="note_files" class="hidden" type="file" accept="image/*,.pdf,.docx,.xlsx" :multiple="true" @change="val => addFile(val)">
                <p class="ml-auto text-[#0080FF] text-xs mt-0.5 cursor-pointer" @click="$refs['note_files'].click()">{{ $t("upload_entity", { entity: $t("files").toLowerCase() }) }}</p>
              </div>
              <div
                v-if="new_note_filenames.length !== 0"
              >
                <div v-for="filename, index in new_note_filenames" :key="filename + index" class="flex mb-[10px]">
                  <p class="text-[#737C89] text-sm ">{{ filename }}</p>
                  <svg class="ml-auto cursor-pointer" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" @click="removeFile(index)">
                    <path d="M17.7729 16.977C17.8786 17.0827 17.938 17.226 17.938 17.3754C17.938 17.5249 17.8786 17.6682 17.7729 17.7739C17.6673 17.8795 17.524 17.9389 17.3745 17.9389C17.2251 17.9389 17.0817 17.8795 16.9761 17.7739L14 14.7968L11.0229 17.7729C10.9173 17.8786 10.774 17.938 10.6245 17.938C10.4751 17.938 10.3317 17.8786 10.2261 17.7729C10.1204 17.6673 10.061 17.5239 10.061 17.3745C10.061 17.225 10.1204 17.0817 10.2261 16.9761L13.2031 14L10.227 11.0229C10.1213 10.9173 10.062 10.7739 10.062 10.6245C10.062 10.475 10.1213 10.3317 10.227 10.2261C10.3327 10.1204 10.476 10.061 10.6254 10.061C10.7749 10.061 10.9182 10.1204 11.0239 10.2261L14 13.2031L16.977 10.2256C17.0827 10.1199 17.226 10.0605 17.3754 10.0605C17.5249 10.0605 17.6682 10.1199 17.7739 10.2256C17.8796 10.3313 17.9389 10.4746 17.9389 10.624C17.9389 10.7735 17.8796 10.9168 17.7739 11.0225L14.7969 14L17.7729 16.977Z" fill="#4B4F54" style="fill:#4B4F54;fill:color(display-p3 0.2941 0.3098 0.3294);fill-opacity:1;"/>
                  </svg>
                </div>
              </div>
              <core-button
                class="mt-3"
                type="coolrunner"
                :disabled="!new_note"
                @click="Addnote()"
                >{{ $t("add") }}
              </core-button>
            </div>
          </div>
        </transition>
        <transition v-if="show" appear name="detail-animation" mode="out-in">
          <div
            class="
              bg-white
              rounded-md
              shadow-sm
              w-full
              pb-7
            "
            :style="{ '--i': 3 }"
          >
            <h4 class="w-5/6 mx-auto pl-0.5 pt-5 text-lg">
              <font-awesome-icon :icon="['far', 'user']" class="mr-2" />
              {{ $t("receiver") }}
            </h4>
            <core-contact
              class="w-5/6 mx-auto mt-3"
              :contact-switch="false"
              :entity="entity.receiver"
              readonly
              :show-country="false"
            />
          </div>
        </transition>
        <transition v-if="show" appear name="detail-animation" mode="out-in">
          <div
            class="
              bg-white
              rounded-md
              shadow-sm
              w-full
              pb-7
              mt-4
            "
            :style="{ '--i': 6 }"
          >
            <h4 class="w-5/6 mx-auto pl-0.5 pt-5 text-lg">
              <font-awesome-icon :icon="['far', 'user']" class="mr-2" />
              {{ $t("sender") }}
            </h4>
            <core-contact
              class="w-5/6 mx-auto mt-3"
              :contact-switch="false"
              :entity="entity.sender"
              readonly
              :show-country="false"
            />
          </div>
        </transition>
        <transition v-if="show" appear name="detail-animation" mode="out-in">
          <div
            v-if="entity.image_count !== 0"
            class="
              bg-white
              rounded-md
              shadow-sm
              w-full
              pb-5
              mt-4
            "
            :style="{ '--i': 8 }"
          >
            <h4 class="px-6 pt-5 w-full font-medium text-lg">
              <font-awesome-icon :icon="['far', 'images']" class="mr-2" />
              {{ $t("images") }}
            </h4>
            <div
              v-for="(image, index) in images"
              :key="index"
              class="w-full grid grid-cols-3"
            >
              <div
                class="col-span-1 w-36 pl-6 py-3 pt-8 md:pt-3 cursor-pointer"
              >
                <el-image
                  :src="
                    `${image}?access_token=${$store.state.auth.access_token}&account_id=${$store.state.account_id}`
                  "
                  @click="modals.galleryDialog.visible = true"
                />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <core-dialog-gallery
      :visible="modals.galleryDialog.visible"
      :images="images"
      @close="modals.galleryDialog.visible = false"
    />
    <return-shipment-dialog
      :visible.sync="modals.returnShipmentDialog.visible"
      :shipment="modals.returnShipmentDialog.shipment"
      @close-returns-dialog="
        () => (modals.returnShipmentDialog.visible = false)
      "
      @refresh-data="() => $emit('refresh-data')"
    />
    <core-tracking-modal :package-number.sync="trackPackage" />
    <core-create-return-portal
      :visible.sync="modals.returnPortalDialog.visible"
      :shipment="modals.returnPortalDialog.shipment"
    />
    <core-document-modal
      :visible.sync="modals.documentViewer.visible"
      :entity="modals.documentViewer.entity"
    />
    <core-file-modal
      v-if="show && entity.claim"
      :visible.sync="modals.fileModal.visible"
      :token="entity.claim.token"
    />
    <core-create-claim
      :visible.sync="modals.createClaim.visible"
      :shipment="modals.createClaim.shipment"
    />
  </div>
</template>

<script>
import { URL_PREFIX, API_PREFIX } from "@/utils/constants";
import moment from "moment";
import I18n from "@/plugins/i18n";
import ReturnShipmentDialog from "./components/ReturnShipmentDialog";
import EventBus from "@/plugins/eventbus";
import { convertUTCToLocal } from "../../utils/date";
import Loader from "@/mixins/Loader";
import Uploader from "@/mixins/S3Upload";
import _ from "lodash";
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from) vm.from = from;
      // access to component instance via `vm`
    });
  },

  name: "ShipmentDetails",
  components: { ReturnShipmentDialog },
  mixins:[Loader, Uploader],
  data: () => ({
    new_note_by_agent: true,
    from: "",
    show: false,
    prevRoute: null,
    endpoint: "shipments",
    new_note: null,
    new_note_files: [],
    new_note_filenames: [],
    new_note_name: null,
    images: [],
    entity: {},
    ticket: null,
    deleted: false,
    actionsVisible: false,
    trackPackage: null,
    status: "",
    delay: 0,
    modals: {
      returnShipmentDialog: {
        visible: false,
        shipment: null
      },
      returnPortalDialog: {
        visible: false,
        shipment: null
      },
      jsonDialog: {
        visible: false,
        orderlines: null
      },
      galleryDialog: {
        visible: false,
        images: []
      },
      documentViewer: {
        visible: false,
        entity: {}
      },
      fileModal: {
        visible: false
      },
      createClaim: {
        visible: false,
        shipment: {}
      },
      countryEndpoint: {
      type: String,
      default: "countries"
    },
    }
  }),
  computed: {
    URL_PREFIX: () => URL_PREFIX,
    API_PREFIX: () => API_PREFIX,
    moment: () => moment,
    updateTicketOkay: function() {
      if (this.$_.some(this.ticket.attributes, {'value': null})) {
        return true
      } else {
        return false
      }
    },
    rowActions: function(entity) {
      let actions = [
        {
          label: I18n.t("download_label"),
          icon: ["far", "file-download"],
          link: item =>
            `${API_PREFIX}/business-panel/shipments/${item.package_number}/label?access_token=${this.$store.state.auth.access_token}&account_id=${this.$store.state.account_id}`
        },
        {
          label: I18n.t("cancel_entity", {
            entity: I18n.tc(this.name).toLowerCase()
          }),
          icon: ["far", "radar"],
          action: item => {
            this.cancelShipment(item);
          },
          hidden: item => !item.cancellable
        },
        {
          label: I18n.t("create_return_portal_link"),
          icon: ["far", "undo"],
          action: item => {
            this.modals.returnPortalDialog.visible = true;
            this.modals.returnPortalDialog.shipment = item;
          }
        },
        {
          label: I18n.t("delete_receiver_data", {
            entity: I18n.tc(this.name).toLowerCase()
          }),
          icon: ["far", "user"],
          action: item => {
            this.deleteReceiverData(item);
          }
        }
      ];

      if (this.$store.state?.account?.business) {
        actions.splice(3, 0, {
          label: I18n.t("create_claim"),
          icon: ["fas", "exclamation-triangle"],
          action: item => {
            this.modals.createClaim.visible = true;
            this.modals.createClaim.shipment = item;
          },
          hidden: item => item.deleted_at || item.cancel_at || item.cancelled_at || item.ticket_id
        });
      }
      if (this.$store.state?.printServices?.length) {
        actions.splice(0, 0, {
          label: I18n.t("print_entity", {
            entity: I18n.tc("label", 1).toLowerCase()
          }),
          icon: ["far", "print"],
          action: item => {
            EventBus.$emit("SHOW_PRINT_DIALOG", printer =>
              this.printLabel(printer, item)
            );
          }
        });
      }
      if (this.$store.state?.account?.business)
        actions.splice(2, 0, {
          label: I18n.t("create_entity", {
            entity: I18n.t("return_shipment").toLowerCase()
          }),
          icon: ["far", "undo"],
          action: item => {
            this.modals.returnShipmentDialog.visible = true;
            this.modals.returnShipmentDialog.shipment = item;
          }
        });
      return actions;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    scrollElement() {
      setTimeout(function() {
        const el = document.getElementById("container");
        el.scrollTop = el.scrollHeight;
      }, 500);
    },
    checkStatus: function(val) {
      if (this.entity.cancel_at) {
        this.status = "cancelled_item";
      } else {
        this.status = val;
      }
    },
    navigate: function() {
      this.show = false;
      document.getElementById("arrow").animate(
        [
          { transform: "translateX(0)", opacity: 1 },
          {
            opacity: 1
          },
          { transform: "translateX(-100%)", opacity: 0 }
        ],
        {
          duration: 250,
          easing: "ease-in-out",
          fill: "forwards"
        }
      );
      if (this.from.name) this.$router.go(-1);
      else this.$router.push({ name: "labels" });
    },
    fetchData() {
      this.loading = true
      if (this.$route.params.id == '1234test') {
        this.show = true;
        this.setTempData()
        this.delay = 1.4;
      } else {
        this.$get(`shipments/${this.$route.params.id}`).then(r => {
          if (r == "OK") {
            this.show = true;
            this.deleted = true;
            this.delay = 0.4;
          } else {
            this.show = true;
            this.entity = r;
            this.checkTicket(this.$route.params.id)
            this.generateImageUrls(r);
            this.delay = 1.4;
          }
        });
      }
    },
    updateTicket: function () {
      this.loading = true
      this.$put(
        `/ticket/case/${this.ticket.id}`,
        this.ticket,
        {
          failSilently: true
        }
      )
        .then(response => {
          this.$notification({
              title: this.$t("claim_updated"),
              type: "success"
            });
          this.loading = false
        })
        .catch(e => {
          this.$notification({
              title: this.$t("error"),
              text: e.message,
              type: "error"
            });
          this.loading = false
        });
    },
    checkTicket: function (id) {
      this.$get(`ticket/shipment/${id}`, undefined, {
        failSilently: true
      }).then(r => {
        this.ticket = r.data
        this.scrollElement()
        }).finally(() => {
          this.loading = false;
        });
    },
    addFileToAtt: function(files, key, index, multiple) {
      this.loading = true
      if (multiple) {
      if (!this.ticket.attributes[index].value) {
        this.ticket.attributes[index].value = []
      }
      _.forEach(files.target.files, (file, key) => {
        this.uploadImage(file, key, this.entity.id).then((value) => {
          this.ticket.attributes[index].value.push(value.key)
        });
      })
      this.loading = false;
      } else {
        this.uploadImage(files.target.files[0], key, this.entity.id).then((value) => {
          this.loading = false;
          this.ticket.attributes[index].value = value.key
        });
      }
    },
    checkContext: function(val) {
      if (val == null || undefined) {
        return this.$t("no_data");
      } else {
        switch (val) {
          case 'frontend':
          case 'panel' :
            return 'Web'
          case 'app':
            return 'App'
          default:
            return 'API'
        }
      }
    },
    checkData: function(val) {
      if (val == null || undefined) {
        return this.$t("no_data");
      } else {
        return val;
      }
    },
    checkCostumsEntity: function(key, val) {
      switch (key) {
        case 'description':
          if (!val || val.length === 0) return this.$t("no_data");
          if (this.$_.isArray(val)) return val[0].description;
          if (this.$_.isObject(val)) return val.description
          break;
        case 'price':
          if (!val || val.length === 0) return this.$t("no_data");
          if (this.$_.isArray(val)) return `${val[0].total_price} ${val[0].currency_code}`;
          if (this.$_.isObject(val)) return `${val.total_price} ${val.currency_code}`
          break;
        case 'tariff':
          if (!val || val.length === 0) return this.$t("no_data");
          if (this.$_.isArray(val)) return val[0].receiver_tariff;
          if (this.$_.isObject(val)) return val.receiver_tariff;
          break;
        case 'origin':
          if (!val || val.length === 0) return this.$t("no_data");
          if (this.$_.isArray(val)) return this.getCountry(val[0].origin_country);
          if (this.$_.isObject(val)) return this.getCountry(val.origin_country);
          break;
        default:
          break;
      }
    },
    getCountry: function(iso){
      let countries = this.$store.state.countries
      let countryName = ''
      countries.forEach(country => {
        if(country.iso == iso) {
          countryName = country.full_name
        }
      })
      return countryName
    },
    getPrice: function(item) {
      return this.$n(
        this.$store.state.account.business
          ? item.order_price.excl_tax
          : item.order_price.incl_tax,
        "decimal",
        "da-DK"
      );
    },
    checkServicePoint: function(val) {
      if (val == null) {
        return this.$t("no_data");
      } else {
        return val.name;
      }
    },
    checkReturn: function(val) {
      if (val) {
        return this.$t("yes");
      } else {
        return this.$t("no");
      }
    },
    formatTime: function(val) {
      return moment(val).format("YYYY-MM-DD HH:mm");
    },
    findInsurence: function(val) {
      if (val == 0 || val == null) {
        return this.$t("no");
      } else if (val == 1) {
        return this.$t("yes");
      } else {
        let product_coverage = {}
      this.$store.state.insurance_products.forEach(productIn => {
        if (productIn.id == val) {
          product_coverage = productIn.coverage
        }
      });
        return `${this.$t("yes")} ${this.$t("up_to")} ${ this.$n(product_coverage, "currency", "da-DK") }`;
      }
    },
    getStatus(status) {
      if (status.key == 'awaiting_customer') return this.$t('awaiting_entity', {entity: this.$store.state.account.business ? this.$store.state.account.company_name : this.$store.state.account.name})
      return status.name
    },
    getClaimType(key) {
      let types = this.$store.state.claim_types.data;
      return this.$_.get(types, [key]);
    },
    generateImageUrls: function(entity) {
      this.images = [];
      for (let i = 0; i < this.entity.image_count; i++) {
        this.images.push(
          `${URL_PREFIX}/business-panel/shipments/${entity.package_number}/image/${i}`
        );
      }
      if (entity.claim?.proof_urls && entity.claim?.proof_urls.length !== 0) {
        entity.claim.proof_urls.forEach(image => {
          if (image.mime_type !== "application/pdf") {
            this.images.push(image.s3_url);
          }
        });
      }
    },
    cancelShipment: function(item) {
      this.$confirm(
        this.$t("confirm_cancellation", {
          type: this.$tc(this.package_number).toLowerCase()
        })
      ).then(() => {
        this.loading = true;
        this.$del(`/${this.endpoint}/${item.id}`)
          .then(() => {
            this.getDataFromApi();
            this.$notification({
              title: this.$t("success"),
              text: `${this.$tc(this.package_number)} ${this.$t(
                "has_been_cancelled"
              ).toLowerCase()}`,
              type: "success"
            });
          })
          .catch(e => {
            this.$notification({
              title: this.$t("not_cancelled"),
              text: `${this.$tc(this.package_number)} ${this.$t(
                "has_not_been_cancelled"
              ).toLowerCase()}`,
              type: "error"
            });
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    deleteReceiverData: function(item) {
      this.$confirm(
        this.$t("confirm_delete", {
          type: this.$tc(this.name).toLowerCase()
        })
      ).then(() => {
        const id = Date.now();
        this.$notification({
          id: id,
          title: this.$t("delete_started"),
          duration: -1
        });
        this.$get(`${this.endpoint}/${item.package_number}/gdpr`, {
          failSilently: true
        })
          .then(response => {
            this.$notification.close(id);
            this.$notification({
              title: this.$t("receiver_data_deleted"),
              duration: 2500
            });
          })
          .catch(e => {
            this.$notification.close(id);
            this.$notification({
              title: this.$t("receiver_data_delete_failed"),
              type: "error"
            });
          });
      });
    },
    goBack: function() {
      this.$router.go(-1);
      document.getElementById("arrow-left").animate(
        [
          // keyframes
          { transform: "translate3d(0, 0px, 0)", opacity: 1 },
          {
            opacity: 1
          },
          { transform: `translate3d(-15px, 0, 0)`, opacity: 0 }
        ],
        {
          // timing options
          duration: 250,
          easing: "ease-in-out",
          fill: "forwards"
        }
      );
    },
    borderColor: function(val) {
      switch (val) {
        case "BOOKED":
          return "border border-gray-300 bg-gray-100";

        case "INFO":
          return "border border-yellow-300";

        case "TRANSIT":
          return "border border-blue-500";

        case "DELIVERED":
          return "border border-green-400";

        case "DEVIATION":
          return "border border-red-400";

        case "RETURN":
          return "border border-blue-400";

        default:
          return "border border-gray-200";
      }
    },
    textColor: function(val) {
      switch (val) {
        case "BOOKED":
          return "text-gray-500";

        case "INFO":
          return "text-yellow-300";

        case "TRANSIT":
          return "text-blue-500";

        case "DELIVERED":
          return "text-green-400";

        case "DEVIATION":
          return "text-red-400";

        case "RETURN":
          return "text-blue-400";

        default:
          return "text-gray-500";
      }
    },
    getFileAttributes: function (file, key) {
      if (!file) {
        return null
      }
      if (!file.includes("https")) {
        let nameArray = file.split("/");
        return nameArray[1]
      }
      let typeArray = file.split(".");
      let typeArray2 = typeArray[5].split("?")
      let nameArray = file.split("/");
      let nameArray2 = nameArray[5].split("?")
      switch (key) {
        case 'type':
          return typeArray2[0]
        case 'name':
          return nameArray2[0]
        default:
          break;
      }
    },
    showFile: function(val) {
      this.modals.documentViewer.entity.url = val.s3_url;
      this.modals.documentViewer.entity.type = "PDF";
      this.modals.documentViewer.entity.name = val.file_name;
      this.modals.documentViewer.visible = true;
    },
    addFile: function(file) {
      this.uploadImage(file.target.files[0], 'note', this.entity.id).then((value) => {
        this.loading = false;
        this.new_note_files.push(value.Key)
        this.new_note_filenames.push(file.target.files[0].name)
      });
    },
    removeFile: function (index) {
      this.new_note_files.splice(index, 1);
      this.new_note_filenames.splice(index, 1);
    },
    Addnote: function() {
      const id = Date.now();
      let message = {
        from_name: this.$store.state.accountRes[0].user.name,
        message: this.new_note,
        files: this.new_note_files
      };
      this.$post(`/ticket/conversation/${this.ticket.conversations[0].id}/message`, message)
        .then(r => {
          this.$notification({
            id: id,
            title: this.$t("note_added"),
            duration: 1000
          });
          this.new_note = null;
          this.new_note_files = [];
          this.new_note_filenames = [];
          this.loading = true
          this.checkTicket(this.$route.params.id)
        })
        .catch(e => {
          this.$notification({
            id: id,
            title: this.$t("note_failed"),
            text: e,
            duration: 1000
          });
        })
        .finally(() => {});
    },
    removeNotice: function() {
      const id = Date.now();
      this.$post(`ticket/conversation/${this.ticket.conversations[0].id}/read`, {}, { failSilently: true })
        .then(r => {
          this.$notification({
            id: id,
            title: this.$t("note_read"),
            duration: 1000
          });
          this.ticket.conversations[0].notification = null;
        })
        .catch(e => {
          this.$notification({
            id: id,
            title: this.$t("note_read_failed"),
            text: e,
            duration: 1000
          });
        })
        .finally(() => {});
    },
    convertUTCToLocal: function(date) {
      return convertUTCToLocal(moment.utc(date));
    },
    goToWMS: function (val) {
      this.show = false;
      this.$router.push({ name: 'wmsorders_details', params: { id: val } });
    },
    setTempData: function () {
      this.entity = {
        alt_package_number:null,
        cancel_at:null,
        cancellable:true,
        carrier:"bring",
        carrier_product:"private",
        carrier_service:"delivery",
        claim: null,
        comment:null,
        consignment_id:null,
        context:"api",
        created_at:"2023-03-20T08:02:33.000000Z",
        currency:null,
        customer_id:7,
        deleted_at:null,
        description:null,
        height:5,
        id:44628056,
        identifier:null,
        image_count:0,
        insurance:0,
        is_return:false,
        label_format:"LabelPrint",
        labelless_code:"123-456-789",
        length:5,
        order_lines:[],
        order_id:12345678,
        orderable_id:'1234test',
        package_number:"370722151435308830",
        pcn_order_id:null,
        order_price:{
          excl_tax:'20',
          incl_tax:'25',
          price_id:'52110'
        },
        rebooked:null,
        receiver: { 
          attention:null,
          city:"Nørresundby",
          country:"DK",
          email:"Lars@test.dk",
          name:"Lars Test",
          notify_email:"Lars@test.dk",
          notify_sms:"+4512345678",
          phone:"+4512345678",
          state:null,
          street1:"Stigsborgvej 60",
          street2:"ST 4",
          zip_code:"9400",
        },
        receiver_state:null,
        redacted:null,
        reference:"Ordre: 123585",
        sender: {
          attention:null,
          city:"Nørresundby",
          country:"DK",
          email:"test@coolrunner.dk",
          id:null,
          name:"Test",
          phone:"54545454",
          state:null,
          street1:"Stigsborgvej 60, 4 th",
          street2:null,
          zip_code:"9400"
        },
        sender_sender_id:null,
        sender_state:null,
        servicepoint:null,
        servicepoint_id:"0",
        shipment_type:null,
        test:false,
        title:"Bring Hjemmelevering (Volume) (0-5kg)",
        updated_at:"2023-03-20T08:02:28.000000Z",
        weight:1200,
        width:5
      };
      if (this.from.path == '/claims') {
        this.entity.claim = {
          compensation_currency_code:"DKK",
          compensation_value:null,
          created_at:"2023-03-14T12:46:12.000000Z",
          currency_code:"DKK",
          description:"Pakke er forsvundet",
          messages:[{
          author:"Test kundeservice",
          date:"2023-03-14 12:46:34",
          message:"Sagen er oprettet, Transportør kontakter",
          }],
          meta: {
          created_by:"Kunde",
          skip_receipt_documentation:0,
          skip_shipment_documentation:0,
          value_includes_shipping:null,
          },
          new_note_by_agent:true,
          new_note_by_customer:false,
          proof_urls:[],
          reference:"89898",
          status:"rejected",
          token:"44410756-1678797972",
          type:"lost",
          updated_at:"2023-03-14T12:46:39.000000Z",
          value:123,
        }
      }
    }
  }
};
</script>

<style scoped>

/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  margin-right: -20px;
}

/* Track */
::-webkit-scrollbar-track {
  border-radius: 100vh;
  background: #ffffff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #157efb;
  border-radius: 100vh;
  transition: 300ms ease-in-out;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #157dfba4;
  transition: 300ms ease-in-out;
}
</style>
